import * as api from "@modules/api";
import { handleDispatchResult } from "@utils/helpers/handleDispatchResult";

import { store } from "../store";
import { SettingActions } from "./slices";

export const checkVoucherValidity = async (
  body: api.Server.CheckVoucherValidityInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(
    SettingActions.checkVoucherValidityAsync(body)
  );
  return handleDispatchResult(res, onSuccess);
};

export const redeemVoucher = async (
  body: api.Server.RedeemVoucherInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(SettingActions.redeemVoucherAsync(body));
  return handleDispatchResult(res, onSuccess);
};

export const redeemb2bVoucher = async (
  body: api.Server.ConsumeBusinessGroupVoucherInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(SettingActions.redeemb2bVoucherAsync(body));
  return handleDispatchResult(res, onSuccess);
};

export const setAutoPlay = async (
  input: api.Server.SetUserAutoplayDisabledInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(SettingActions.setAutoPlayAsync(input));
  return handleDispatchResult(res, onSuccess);
};

export const setNextTitle = async (
  input: api.Server.SetUserNextTitleDisabledInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(SettingActions.setNextTitleAsync(input));

  return handleDispatchResult(res, onSuccess);
};

export const removeMultiDownloads = async (
  input: api.Server.RemoveMultiDownloadContentEntityInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(SettingActions.removeDownloadsAsync(input));
  return handleDispatchResult(res, onSuccess);
};
